import React from "react";
import { Link } from "react-router-dom";

const MenuEnsinoEspecialTurma = ({ inicioUrl, menuOpcaoAtivo, acessos }) => {
    return (
        <div className="menu-detalhe-curso menu-detalhe-curso-v2">
            <div className="container">
                <ul>
                    <li>
                        <Link to={`${inicioUrl}/visao-geral`} className={menuOpcaoAtivo === "visao-geral" ? "ativo" : ""}>
                            Alunos
                        </Link>
                    </li>
                    {acessos?.includes(14) && (
                        <li>
                            <Link
                                to={`${inicioUrl}/atendimentos`}
                                className={
                                    menuOpcaoAtivo === "atendimentos" ||
                                    menuOpcaoAtivo === "relatorios-atendimento" ||
                                    menuOpcaoAtivo === "atendimento-detalhe"
                                        ? "ativo"
                                        : ""
                                }
                            >
                                Diário
                            </Link>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default MenuEnsinoEspecialTurma;
